<template>
  <MainLayout>
    <div class="ActivityLunch">
      <div class="activityContainer">
        <div class="contact">
          <p>咨询赛事与商务合作，请直接拨打我们的电话或者填写表单，我们将在第一时间响应。</p>{{$t('global.联系人')}}：Lizki
          <br>{{$t('global.手机号')}}：18701836024
          <br>{{$t('global.座机号')}}：021-52998050
          <br>邮&nbsp;&nbsp;&nbsp;箱：liz.li@manamana.net
          <br>
        </div>
      </div>
      <el-form ref="form" :rules="rules" :model="form">
        <div class="activityContainer">
          <el-form-item prop="companyName" :label="$t('global.公司名称')">
            <el-input type="text" :placeholder="$t('global.请输入公司名称')" v-model="form.companyName"></el-input>
          </el-form-item>
          <el-form-item prop="name" :label="$t('global.联系人')">
            <el-input type="text" :placeholder="$t('global.请输入联系人')" v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item prop="phone" :label="$t('global.联系电话')">
            <el-input type="text" :placeholder="$t('global.请输入联系电话')" v-model="form.phone"></el-input>
          </el-form-item>
          <el-form-item prop="email" :label="$t('global.电子邮箱')">
            <el-input type="text" :placeholder="$t('global.请输入电子邮箱')" v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item prop="body" :label="$t('global.详细需求')">
            <el-input type="textarea" :rows="5" :placeholder="$t('global.请输入详细需求')" v-model="form.body"></el-input>
          </el-form-item>
        </div>
        <div class="button-wrap">
          <el-button class="confirm button" @click="submit('form')">{{$t('global.提交')}}</el-button>
        </div>
      </el-form>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";

export default {
  name: "addmatch",
  metaInfo() {
    return {
      title: this.$t("global.创建比赛") + " | MANA"
    };
  },
  components: { MainLayout },
  data() {
    return {
      rules: {
        companyName: [
          {
            validator: this.$validate(this.$t('global.请输入公司名称')).null,
            trigger: "change"
          }
        ],
        name: [
          {
            validator: this.$validate(this.$t('global.联系人名字')).name,
            trigger: "change"
          }
        ],
        phone: [
          {
            validator: this.$validate(this.$t('global.联系电话')).tel,
            trigger: "change"
          }
        ],
        email: [
          {
            validator: this.$validate(this.$t('global.电子邮箱')).email,
            trigger: "change"
          }
        ],
        body: [
          {
            validator: this.$validate(this.$t('global.请输入详细需求')).null,
            trigger: "change"
          }
        ]
      },
      form: {
        companyName: "",
        name: "",
        phone: "",
        email: "",
        body: ""
      }
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    updata() {
      this.$http.post("/api/activity/send/email", this.form).then(response => {
        this.$message({
          message: response.message,
          type: "success",
          onClose() {
            window.history.go(-1);
          }
        });
      });
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.updata();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
.activityContainer >>> .el-form-item__label {
  padding: 0 0 6px;
  font-size: 0.24rem;
  color: #000;
}

.activityContainer {
  background: #fff;
  width: 19.5rem;
  margin: 0.5rem auto;
  padding: 0.62rem 3.7rem;
  box-sizing: border-box;
}

.ActivityLunch {
  .contact {
    color: #000;
    font-size: 0.18rem;
    letter-spacing: 1px;
    line-height: 0.35rem;
    font-family: initial;

    p {
      margin-bottom: 0.24rem;
    }
  }

  .button-wrap {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0.4rem;

    .button {
      width: 2.5rem;
      height: 0.64rem;
      // line-height: 0.68rem;
      text-align: center;
      margin: 0 auto;
      border-radius: 0.9rem;
      font-size: 0.24rem;
    }

    .confirm {
      background-color: #0060ff;
      color: #ffffff;
    }

    .cancle {
      background-color: #eee;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/addmatch.vue